// TODO: refactor those imports in typescript
import i18n from '../../../../../utils/i18n'

import * as React from 'react'
import { StoreProps } from '../../../../services/stores/casting.store'
import StepperInputComponent from '../../../shared/stepper-input.component'

interface Props {
  store: StoreProps['store']
  data: Pick<StoreProps['data'], 'offeredService' | 'participantsNumber'>
}

export default function CastingParticipantsNumberInputComponent ({ store, data: { offeredService, participantsNumber } }: Props) {
  // Use the legacy i18n because of allowed transation (not yet supported in the new i18n service)
  return <StepperInputComponent
    formatter={ value => i18n('casting_steps.step_2.inputs.participants_number_input', value) }
    style={{ marginBottom: '0.75em' }}
    name="participants_number"
    value={ participantsNumber }
    onChange={ value => store.set({ participantsNumber: value }) }
    min={ offeredService.participant_min }
    max={ offeredService.participant_max || 999 } 
  />
}
